import { PERMISSIONS } from '@/access/permissions';
import { FEATURES } from '@/access/features';
import { ROLES } from '@/access/roles';

const navigation = [
  {
    text: 'Home',
    icon: 'welcome',
    path: '/',
    exact: true,
  },
  {
    text: 'Contacts',
    icon: 'contacts',
    path: '/contacts',
    permission: PERMISSIONS.CONTACTS,
  },
  {
    text: 'Groups',
    icon: 'groups',
    path: '/groups',
    permission: PERMISSIONS.CONTACTS,
  },
  {
    text: 'Conversations',
    icon: 'conversations',
    path: '/conversations',
    permission: PERMISSIONS.CONVERSATIONS,
  },
  {
    text: 'Campaigns',
    icon: 'campaigns',
    path: '/campaigns',
    permission: PERMISSIONS.CAMPAIGNS,
  },
  {
    text: 'Lessons',
    icon: 'lessons',
    path: '/lessons',
    permission: PERMISSIONS.LESSONS,
  },
  {
    text: 'Automations',
    icon: 'automations',
    path: '/automations',
    permission: PERMISSIONS.AUTOMATIONS,
  },
  {
    text: 'Reports',
    icon: 'reports',
    path: '/reports',
  },
  {
    text: 'Agents',
    icon: 'smart_toy',
    fontIcon: true,
    path: '/agents',
    feature: FEATURES.CUSTOM_AGENTS,
    roles: [ROLES.ADMIN],
  },
];

// hidden in more bucket
const secondaryNavigation = [
  {
    text: 'Tasks',
    icon: 'tasks',
    path: '/tasks',
    feature: FEATURES.TASKS,
  },
  {
    text: 'Files',
    icon: 'collections',
    fontIcon: true,
    path: '/files',
    feature: FEATURES.FILES,
  },
  {
    text: 'Snippets',
    icon: 'snippets',
    path: '/snippets',
    feature: FEATURES.SNIPPETS,
  },
  {
    text: 'Custom Objects',
    icon: 'data_object',
    fontIcon: true,
    path: '/custom-objects',
    permissions: [
      PERMISSIONS.CUSTOM_OBJECTS,
      PERMISSIONS.MANAGE_CUSTOM_RECORDS,
      PERMISSIONS.MANAGE_CUSTOM_OBJECTS,
    ],
    feature: FEATURES.CUSTOM_OBJECTS,
  },
  {
    text: 'Forms',
    icon: 'description',
    fontIcon: true,
    path: '/forms',
    feature: FEATURES.FORMS,
    permissions: [
      PERMISSIONS.MANAGE_FORMS,
      PERMISSIONS.VIEW_FORM_SUBMISSIONS,
      PERMISSIONS.CREATE_FORM_SUBMISSIONS,
    ],
  },
  {
    text: 'Territory Info',
    icon: 'map',
    fontIcon: true,
    path: '/territory-info',
    feature: FEATURES.VMC_STUDENT_DB,
    roles: [ROLES.ADMIN],
  },
  {
    text: 'Other Tools',
    icon: 'build',
    fontIcon: true,
    path: '/tools',
    feature: FEATURES.CUSTOM_OBJECTS,
    permissions: [
      PERMISSIONS.CUSTOM_OBJECTS,
      PERMISSIONS.MANAGE_CUSTOM_RECORDS,
      PERMISSIONS.MANAGE_CUSTOM_OBJECTS,
    ],
    requiresStandaloneObjects: true,
  },
];

const resources = [
  {
    text: 'Help Docs',
    icon: 'help',
    href: 'https://conveyour.com/help',
  },
  {
    text: 'Video Gallery',
    icon: 'videos',
    href: 'https://conveyour.com/videos',
  },
];

export { navigation, secondaryNavigation, resources };
